import { z } from 'zod';

/** GCS folder + DB primary key: `batch_YYYY-MM-DD_{cuid2}` (UTC date). */
export const UPLOAD_BATCH_ID_REGEX = /^batch_\d{4}-\d{2}-\d{2}_[a-z0-9]+$/;

/** Accepts new batch ids and legacy cuid2 ids (in-flight uploads). */
export const UploadIdSchema = z.union([
  z.string().regex(UPLOAD_BATCH_ID_REGEX),
  z.string().cuid2(),
]);
